export default __webpack_public_path__ + "static/media/picto_venez.75c4a10f.png";